module.exports = __webpack_public_path__ + "img/app_login.6124c694.jpg";